import AnalyticsService from "data/firestore/analytics";
import { useEffect } from "react";
import useCustomSnackbar from "hooks/customSnackbar";
import useCustomNavigation from "hooks/customNavigation";

const NotificationHandler = () => {
  const { enqueueSnackbar } = useCustomSnackbar();
  const navigate = useCustomNavigation();

  const showToast = (message, variant, type) => {
    enqueueSnackbar(message, {
      variant: variant,
      persist: true,
    });
    AnalyticsService.event("notification_shown", {
      variant: variant,
      type: type,
    });
  };

  useEffect(() => {
    // Handle toast display events
    const handleShowToast = (event) => {
      const { message, variant, type } = event.detail;
      showToast(message, variant, type);
    };

    // Handle navigation events (for buddies notifications)
    const handleNavigate = (event) => {
      const { url } = event.detail;
      navigate(url);
    };

    // Add event listeners
    window.addEventListener("showToast", handleShowToast);
    window.addEventListener("navigate", handleNavigate);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("showToast", handleShowToast);
      window.removeEventListener("navigate", handleNavigate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar]);

  // This component doesn't render anything
  return null;
};

export default NotificationHandler;
